"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LoginForm", {
  enumerable: true,
  get: function get() {
    return _LoginForm.default;
  }
});
Object.defineProperty(exports, "RichText", {
  enumerable: true,
  get: function get() {
    return _RichText.default;
  }
});
Object.defineProperty(exports, "GatsbyImage", {
  enumerable: true,
  get: function get() {
    return _GatsbyImage.default;
  }
});
Object.defineProperty(exports, "isLoggedIn", {
  enumerable: true,
  get: function get() {
    return _auth.isLoggedIn;
  }
});
Object.defineProperty(exports, "logout", {
  enumerable: true,
  get: function get() {
    return _auth.logout;
  }
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _JamCMS = _interopRequireDefault(require("./components/JamCMS"));

var _LoginForm = _interopRequireDefault(require("./components/LoginForm"));

var _RichText = _interopRequireDefault(require("./components/RichText"));

var _GatsbyImage = _interopRequireDefault(require("./components/GatsbyImage"));

var _Seo = _interopRequireDefault(require("./components/Seo"));

var _auth = require("./utils/auth");

var _utils = require("./utils"); // import app components


var Index = function Index(props) {
  var source = props.source,
      settings = props.settings,
      children = props.children; // Check if user has access to jamCMS.

  var allowAccess = (0, _utils.validateAccess)();

  if (allowAccess && !(settings !== null && settings !== void 0 && settings.decouple)) {
    return /*#__PURE__*/_react.default.createElement(_JamCMS.default, props);
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Seo.default, props), /*#__PURE__*/_react.default.cloneElement(children, {
      source: source,
      settings: settings
    }));
  }
};

var _default = Index; // Export all frontend components / functions

exports.default = _default;